<div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12 p-md-3">
        <div><strong>Stream To</strong></div>
    </div>
    <div class="p-field p-col-12 p-md-9">
        <p-dropdown [options]="destinations" [(ngModel)]="streamTo" placeholder="Select a destination"></p-dropdown>
    </div>
    <p class="p-field p-col-12 status-text" [hidden]="user.standard_subscribe_id">Please subscrible the standard plan to
        use streaming service.</p>
    <p class="p-field p-col-12 status-text" [hidden]="user.youtube_link || streamTo != 'youtube'">Please put your Closed
        Captions URL for Youtube
        streaming.</p>
    <div class="p-field p-col-12 p-d-flex">
        <button pButton pRipple *ngIf="!isStreaming" type="button" icon="pi pi-volume-up"
            class="p-button-rounded p-button-danger p-button-lg" (click)="doStream()"
            [disabled]="!(user.standard_subscribe_id && (user.youtube_link && streamTo == 'youtube'))"></button>
        <button pButton pRipple *ngIf="isStreaming" type="button" icon="pi pi-volume-off"
            class="p-button-rounded p-button-secondary p-button-lg" (click)="stopStream()"></button>
        <div class="p-m-2">{{speachToTextDesc}}</div>
    </div>
    <p class="p-field p-col-12 status-text" id="status">Not Started</p>
    <table id="messages" placeholder="Your speech-to-text output will appear here."
        class="p-field p-col-12 message-border">
    </table>
</div>